// Which case identifier fills the "Case reference number" on generated care
// documents (careDocuments.caseReferenceSource org setting):
// - gipCode: the L&G referral's GIP code (rendered GIP-prefixed)
// - policyNumber: the patient's policy number (Aviva)
// - none: documents carry no case reference — the field is not shown
export enum CaseReferenceSource {
  none = 'none',
  gipCode = 'gipCode',
  policyNumber = 'policyNumber',
}
